import { fullRegionSchema } from './full-region.schema';
import { regionDetailsSchema } from './region-details.schema';
import { z } from 'zod/v4';

export const availableRegionsSchema = z.object({
  fullRegions: z.array(fullRegionSchema),
  regionDetails: regionDetailsSchema,
});

export type AvailableRegions = z.infer<typeof availableRegionsSchema>;
